import React from "react";
import wretch from "wretch";
import PropTypes from "prop-types";
import RoleTypes from "../roles";
import { domain, token, selectedClientId, roles } from "./ServiceConfig";
import { quickLogEvent } from "./LogService";
import AuthService from "./AuthService";

const Auth = new AuthService();

class UserService extends React.Component {
  // User Functions //
  // registerUser
  // resendRegistrationEmail
  // requestVerification
  // verifyToken
  // get
  // getByUserId
  // getAllUsers
  // addUser
  // updateUser
  // updatePhoneNumber
  // getUsers
  // getUsersAnonymous
  // deleteUser
  // requestPasswordReset
  // validateResetPassword
  // updatePassword
  // addRole
  // removeRole
  // getPossibleRoles
  // checkUserRole
  // addClient
  // removeClient
  // GetAllForAClient

  registerUser = (json) => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/users/RegisterUser")
        // Authorization header
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post(json)
        .json((res) => {
          quickLogEvent("Register User", 1, "Registered a User");
          return Promise.resolve(res);
        })
    );
  };

  resendRegistrationEmail = (userId) => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/users/ResendEmail")
        // Authorization header
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post({ userId: userId })
        .json((res) => {
          quickLogEvent("Email Sent", 1, "Sent Registration Email");

          return Promise.resolve(res);
        })
    );
  };

  requestVerificationByUserId = () => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/users/VerifyPhoneByUserId")
        // Authorization header
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post()
        .json((res) => {
          quickLogEvent("Verification", 1, "Request Verification by User Id");
          return Promise.resolve(res);
        })
    );
  };

  requestVerification = (phone, method) => {
    var json = "{'phone':'" + phone + "','method':'" + method + "'}";

    return (
      wretch()
        // Set the base url
        .url(domain + "/users/VerifyPhone")
        // Authorization header
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post(json)
        .json((res) => {
          return Promise.resolve(res);
        })
    );
  };

  verifyTokenWithUserId = (code, remember) => {
    var json = "{'token':'" + code + "','remember':'" + remember + "'}";
    console.log("verifyTokenWithUserId", json);

    return (
      wretch()
        // Set the base url
        .url(domain + "/users/VerifyTokenByUserId")
        // Authorization header
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post(json)
        .json((res) => {
          return Promise.resolve(res);
        })
    );
  };

  validateUser = (newuser) => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/users/ValidateUser")
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post(newuser)
        .json((res) => {
          if (Boolean(res.errorMessage) === false) {
            return Promise.resolve(res);
          } else {
            return Promise.reject(res.errorMessage);
          }
        })
    );
  }

  verifyToken = (phone, usertoken) => {
    var json = "{'phone':'" + phone + "','token':'" + usertoken + "'}";

    return (
      wretch()
        // Set the base url
        .url(domain + "/users/VerifyToken")
        // Authorization header
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post(json)
        .json((res) => {
          return Promise.resolve(res);
        })
    );
  };

  getUserInfoWithFingerPrint = (fingerprint) => {
    if (fingerprint != null) {
      return (
        wretch()
          // Set the base url
          .url(domain + "/users/GetWithFingerPrint?fingerprint=" + fingerprint)
          // Authorization header
          .auth(`Bearer ` + token())
          // Cors fetch options
          .options({ credentials: "include", mode: "cors" })
          .get()
          .json((res) => {
            return Promise.resolve(res);
          })
      );
    } else {
      return (
        wretch()
          // Set the base url
          .url(domain + "/users/get")
          // Authorization header
          .auth(`Bearer ` + token())
          // Cors fetch options
          .options({ credentials: "include", mode: "cors" })
          .get()
          .json((res) => {
            return Promise.resolve(res);
          })
      );
    }
  };

  // Get User info including list of roles and client(s)
  getUserInfo = () => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/users/get")
        // Authorization header
        .auth(`Bearer ` + token())
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .get()
        .json((res) => {
          return Promise.resolve(res);
        })
    );
  };

  // Get User info including list of roles and client(s)
  get = () => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/users/get")
        // Authorization header
        .auth(`Bearer ` + token())
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .get()
        .json((res) => {
          return Promise.resolve(res);
        })
        .catch((error) => {
          return Promise.reject("Failed");
        })
    );
  };

  getByUserId = (userId) => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/users/GetUserInfo?userId=" + userId)
        // Authorization header
        .auth(`Bearer ` + token())
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .get()
        .unauthorized((error) => {
          Auth.logout();
          window.location.href = "/";
        })
        .json((res) => {
          return Promise.resolve(res);
        })
    );
  };

  getAllUsers = () => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/users/GetAllUsers")
        // Authorization header
        .auth(`Bearer ` + token())
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .get()
        .json((res) => {
          return Promise.resolve(res);
        })
        .catch((error) => {
          return Promise.reject("Failed");
        })
    );
  };

  addUser = (newuser) => {
    // console.log("got to service call to add user", newuser);
    // console.log("called");
    // console.log(domain + "/users/Add");

    return (
      wretch()
        // Set the base url
        .url(domain + "/users/Add")
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post(newuser)
        .json((res) => {
          console.log("Add User Response", res);
          console.log("POST payload", newuser);
          quickLogEvent("Add User", 1, "Added a User");
          if (Boolean(res.errorMessage) === false) {
            return Promise.resolve(res);
          } else {
            return Promise.reject(res.errorMessage);
          }
        })
    );
  };

  updateUser = (json) => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/users/Update")
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post(json)
        .json((res) => {
          if (json && json.userId && json.userName && json.email) {
            quickLogEvent(
              "Update User",
              1,
              "Updated user " +
                json.username +
                " with id = " +
                json.userid +
                " and email = " +
                json.email
            );
          }
          return Promise.resolve(res);
        })
    );
  };

  updatePhoneNumber = (userId, phoneNumber) => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/users/UpdatePhoneNumber")
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post({
          userId: userId,
          phoneNumber: phoneNumber,
        })
        .json((res) => {
          return Promise.resolve(res);
        })
    );
  };

  getUsers = () => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/values/GetUSers")
        // Authorization header
        .auth(`Bearer ` + token())
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .get()
        .json((res) => {
          return Promise.resolve(res);
        })
        .catch((error) => {
          return Promise.reject("Failed");
        })
    );
  };

  getUsersAnonymous = () => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/values/GetUSers2")
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .get()
        .json((res) => {
          return Promise.resolve(res);
        })
    );
  };

  deleteUser = (userId) => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/users/Delete")
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post({ userId })
        .json((res) => {
          quickLogEvent("Delete User", 1, "Deleted a User");
          if (Boolean(res.errorMessage) === false) {
            return Promise.resolve(res);
          } else {
            return Promise.reject(res.errorMessage);
          }
        })
    );
  };

  // Password Functions

  // Reset User Password
  requestPasswordReset = (username, email, baseURL) => {
    // check for both parameters before making an api call

    if (username && email) {
      return wretch()
        .url(`${domain}/ForgotPassword/Post`)
        .headers({ "Content-Type": "application/json;charset=utf-8" })
        .options({ credentials: "include", mode: "cors" })
        .post({
          UserName: username,
          Email: email,
          ResetPasswordBaseUrl: baseURL,
        })
        .json((response) => {
          quickLogEvent(
            "Password Reset",
            1,
            "Requested that password be reset."
          );
          return Promise.resolve(response);
        })
        .catch((error) => {
          return Promise.reject("Failed");
        });
    } else {
      return Promise.reject("Failed");
    }
  };

  // Call this function to verify that the QUID passed to the Password Reset
  // page is valid. The QUID is emailed to the user when they request a change
  validateResetPassword = (userId, code) => {
    // check for both parameters before making an api call
    if (userId && code) {
      return wretch()
        .url(
          domain + "/ForgotPassword/Verify?userid=" + userId + "&code=" + code
        )
        .get()
        .json((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          return Promise.reject("Failed");
        });
    } else {
      return Promise.reject("Failed");
    }
  };

  // Reset User Password
  updatePassword = (request) => {
    if (request) {
      return wretch()
        .url(`${domain}/ForgotPassword/ResetPassword`)
        .headers({ "Content-Type": "application/json;charset=utf-8" })
        .options({ credentials: "include", mode: "cors" })
        .post({
          UserId: request.userQuid,
          Code: request.codeQuid,
          NewPassword: request.password,
        })
        .json((response) => {
          quickLogEvent("Update Password", 1, "Updated User Password");
          return Promise.resolve(response);
        })
        .catch((error) => {
          return Promise.reject("Failed");
        });
    } else {
      return Promise.reject("Password Change Failed");
    }
  };

  // Role Functions

  addRole = (userId, roleId) => {
    var json = "{'userId':'" + userId + "','roleId':'" + roleId + "'}";

    return (
      wretch()
        // Set the base url
        .url(domain + "/users/AddRole")
        // Authorization header
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post(json)
        .json((res) => {
          quickLogEvent(
            "Add Role",
            1,
            "Added Role " + roleId + " for " + userId
          );
          return Promise.resolve(res);
        })
    );
  };

  removeRole = (userId, roleId) => {
    var json = "{'userId':'" + userId + "','roleId':'" + roleId + "'}";

    return (
      wretch()
        // Set the base url
        .url(domain + "/users/RemoveRole")
        // Authorization header
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post(json)
        .json((res) => {
          quickLogEvent(
            "Remove Role",
            1,
            "Removed Role " + roleId + " for " + userId
          );

          return Promise.resolve(res);
        })
    );
  };

  getPossibleRoles = (userId) => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/roles/GetAvailableForUser?userId=" + userId)
        // Authorization header
        .auth(`Bearer ` + token())
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .get()
        .json((res) => {
          return Promise.resolve(res);
        })
    );
  };

  checkUserRole = (role) => {
    console.log("roles passed to checkUserRole =", roles());
    const rolesList = roles().toString();
    if (rolesList && rolesList.indexOf(role) > -1) {
      return true;
    }
    return false;
  };

  // Client Functions

  addClient = (userId, clientId) => {
    var json = "{'userId':'" + userId + "','clientId':" + clientId + "}";

    return (
      wretch()
        // Set the base url
        .url(domain + "/users/AddClient")
        // Authorization header
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post(json)
        .json((res) => {
          quickLogEvent(
            "Add Client",
            1,
            "Added Client " + clientId + " for " + userId
          );
          return Promise.resolve(res);
        })
    );
  };

  addGroup = (userId, groupId) => {
    var json = "{'userId':'" + userId + "','groupId':" + groupId + "}";

    return (
      wretch()
        // Set the base url
        .url(domain + "/users/AddGroup")
        // Authorization header
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post(json)
        .json((res) => {
          quickLogEvent(
            "Add Group",
            1,
            "Added Group " + groupId + " for " + userId
          );
          return Promise.resolve(res);
        })
    );
  };

  removeClient = (userId, clientId) => {
    var json = "{'userId':'" + userId + "','clientId':" + clientId + "}";

    console.log(json);

    return (
      wretch()
        // Set the base url
        .url(domain + "/users/RemoveClient")
        // Authorization header
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post(json)
        .json((res) => {
          quickLogEvent(
            "Remove Client",
            1,
            "Removed Client " + clientId + " for " + userId
          );
          return Promise.resolve(res);
        })
    );
  };

  getAllForAClient = (clientId = selectedClientId()) => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/Users/GetAllForAClient?clientId=" + clientId)
        // Authorization header
        .auth(`Bearer ` + token())
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .get()
        .json((res) => {
          return Promise.resolve(res);
        })
    );
  };

  deactivateUser = (userId) => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/users/DeactivateUser")
        // Authorization header
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post({ userId })
        .json((res) => {
          return Promise.resolve(res);
        })
    );
  };

  reactivateUser = (userId) => {
    return (
      wretch()
        // Set the base url
        .url(domain + "/users/ActivateUser")
        // Authorization header
        .auth(`Bearer ` + token())
        .headers({ "Content-Type": "application/json" })
        // Cors fetch options
        .options({ credentials: "include", mode: "cors" })
        .post({ userId })
        .json((res) => {
          return Promise.resolve(res);
        })
    );
  };

  // Determine if user is in demo mode
  // For demo mode, user must have the role 'demo' assigned through the admin center
  getDemoModeStatus = () => {
    return this.checkUserRole(RoleTypes.Demo) ? true : false;
  };

  setPrivacyMode = (value) => {
    if (value === true) {
      sessionStorage.setItem("sensitive", "true");
      let $style = document.createElement("style");
      $style.id = "sensitiveMode";
      $style.innerHTML = `.sensitive { filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius='3');
          -webkit-filter: url(#blur-filter);
          filter: url(#blur-filter);
          -webkit-filter: blur(3px);
          filter: blur(3px); }`;
      document.head.appendChild($style);
    } else {
      var el = document.getElementById("sensitiveMode");
      if (el) {
        el.remove();
      }
      sessionStorage.setItem("sensitive", "false");
    }
  };
}

// Get List of RoleTypes from roles.js in Root
UserService.propTypes = {
  roleTypes: PropTypes.oneOf(Object.keys(RoleTypes)),
};
// Add PropType of Roles to UserService
UserService.roleTypes = RoleTypes;

export default UserService;
